import React from "react";
import { TemplateFormData } from "../../../views/marketing-pages/templates";
import { CharCount, SectionLabel } from "./utiz";
import { RadioGroup } from "../../radio";
import { HeaderType, MediaType } from "../../../views/marketing-pages/templates/types";
import Input from "../../input";
import { Upload } from "lucide-react";

export const HeaderSection: React.FC<{ formData: TemplateFormData; onChange: (u: Partial<TemplateFormData>) => void }> = ({ formData, onChange }) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  // Helper for header text change
  const handleHeaderTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ headerText: e.target.value });
  };

  return (
    <div>
      <SectionLabel label="Header" optional />
      <RadioGroup
        name="headerType"
        options={[{ label: 'None', value: 'none' }, { label: 'Text', value: 'text' }, { label: 'Media', value: 'media' }]}
        value={formData.headerType}
        onChange={(v) => onChange({ headerType: v as HeaderType })}
      />
      {formData.headerType === 'text' && (
        <div className="mt-3">
          <p className="text-xs text-gray-600 dark:text-gray-400 mb-1.5 font-medium">Title</p>
          <div className="relative">
            <Input 
              value={formData.headerText} 
              onChange={handleHeaderTextChange} 
              placeholder="Add a header title"  
            />
            <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-indigo-600 dark:text-indigo-400 font-medium hover:text-indigo-800 dark:hover:text-indigo-300 transition-colors">
              Add variable
            </button>
          </div>
          <CharCount current={formData.headerText.length} max={60} extra="0/1 Variable" />
        </div>
      )}
      {formData.headerType === 'media' && (
        <div className="mt-3 space-y-3">
          <div>
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-1.5 font-medium">Media Type</p>
            <RadioGroup
              name="mediaType"
              options={[{ label: 'Image', value: 'image' }, { label: 'Video', value: 'video' }, { label: 'Document', value: 'document' }]}
              value={formData.mediaType}
              onChange={(v) => onChange({ mediaType: v as MediaType })}
            />
          </div>
          <div>
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-1.5 font-medium">
              {formData.mediaType === 'image' ? 'Image Upload' : formData.mediaType === 'video' ? 'Video Upload' : 'Document Upload'}
            </p>
            <div className="flex items-center gap-0 border border-gray-200 dark:border-gray-600 rounded-lg overflow-hidden">
              <div className="flex-1 px-3 py-2.5 flex items-center gap-2 min-w-0">
                {formData.mediaFileName
                  ? <><Upload size={14} className="text-[#7B7B7B] font-semibold dark:text-gray-500 flex-shrink-0" /><span className="text-sm text-gray-700 dark:text-gray-300 truncate">{formData.mediaFileName}</span></>
                  : <span className="text-sm text-[#7B7B7B] font-semibold dark:text-gray-500">Upload sample media</span>
                }
              </div>
              <button
                type="button"
                onClick={() => fileInputRef.current?.click()}
                className="bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium px-4 py-2.5 transition-colors flex-shrink-0"
              >
                Browse Files
              </button>
            </div>
            <input
              ref={fileInputRef} type="file" className="hidden"
              accept={formData.mediaType === 'image' ? 'image/*' : formData.mediaType === 'video' ? 'video/*' : '.pdf,.doc,.docx'}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) onChange({ mediaFile: file, mediaFileName: file.name });
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};